import React, { Component } from "react";
import { Modal,  FormGroup, FormControl, ControlLabel, HelpBlock } from "react-bootstrap";
import { Grid, Row, Col } from "react-bootstrap";

import PropTypes from "prop-types";
import Select from 'react-select';

import Constants from '../../../Phi/Constants'
import UploadDoc from "dataphi-react-components/dist/Containers/DataphiUploadDocContainer/Component/UploadDocComponent";
import FormComponent from "dataphi-react-components/dist/Containers/FormScreen/FormComponent";

import Image from "../../../Assets/upload.png";

import moment from 'moment';
import DatePicker from 'react-datepicker'

import './UploadDocumentPopup.css'

const HSGPopupBackdropStyle = {
    top: 0,
    backgroundColor: "#000",
    opacity: 0.5
};

const styleDefs = {
    dataphiUploadDocUploadBlock: "hsg-hh-upload-doc-block",
    dataphiUploadDocUploadImgBtn: "hsg-hh-upload-doc-hh-upload-img-btn",
    dataphiUploadDocUploadBlockContent: "hsg-hh-upload-doc-hh-upload-block-content",
    dataphiUploadDocTitle: "hsg-hh-upload-doc-title",
    dataphiUploadDocLabel: "hsg-hh-upload-doc-label",
    dataphiUploadDocUploadImgUploadBtnText: "hsg-hh-upload-doc-hh-upload-img-hh-upload-btn-text",
    dataphiUploadDocUploadImgBtnDisabled: "hsg-hh-upload-doc-hh-upload-img-btn-disabled",
    dataphiUploadDocUploadImg: "hsg-hh-upload-doc-hh-upload-img",
    dataphiUploadDocUploadImgDefault: "hsg-hh-upload-doc-hh-upload-img-default",
    dataphiUploadDocUploadBtn: "hsg-hh-upload-doc-hh-upload-btn",
    dataphiUploadDocError: "hsg-error"
};

const fileErrorMessage = {
    fileSize: "File exceeds the specified limit",
    multiNotAllowed: "Uploading more then a single file is not allowed"
};

export default class HSGPopupComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentImageObject: [],
            currentImageTags: [],
            currentImageReamrks: ''
        };
    }

    getPopUpHeader = headerText =>
        headerText ? <div className="hsg-card-header-label col-md-6 col-sm-6 col-xs-6">{headerText}</div> : null;
    getPopUpHeaderRight = headerText =>
        headerText ? (
            <div className="hsg-card-header-label col-md-6 col-sm-6 col-xs-6" style={{ textAlign: "right" }}>
                {headerText}
            </div>
        ) : null;

    getForm = ({ formDefs, onClose, onSubmit, onBlur }) => (
        <FormComponent onClose={onClose} onSubmit={onSubmit} formDefs={formDefs} onFieldBlur={onBlur} />
    );

    getButtonActions = (e, onClick) => {
        e.preventDefault();
        onClick && onClick(e);
        //this.props.onHide && this.props.onHide();
    };

    getButtons = buttons => (
        <div className="text-right">
            {buttons.map((button, i) => (
                <button
                    key={i}
                    className={button.className || "hsg-btn"}
                    onClick={e => this.getButtonActions(e, button.onClick)}
                >
                    {button.text}
                </button>
            ))}
        </div>
    );

    getBody = (bodyText, buttons) =>
        bodyText ? (
            <div>
                {bodyText}
                {buttons && buttons.length && this.getButtons(buttons)}
            </div>
        ) : null;

    errorWhileUpload = data => {
        this.setState({ fileUploadErrorMessage: fileErrorMessage[data] || "Something went wrong." });
    };   

    _renderInfoDiv = () => {
        let imageTags = this.props.imageTags || []

        return (
            <div className="hsg-hh-upload-pic" style = {{marginTop: 5, paddingBottom: 0}}>

                {/* {
                    !!!this.props.hideRemarks ? <Select 
                        value = {this.state.currentImageTags} 
                        onChange = {(e) => this.setState({currentImageTags : e ? e : ''})}
                        options = {
                            imageTags.map((tab, index) => (
                                { key:index, value: tab.json_value.value, label: tab.json_value.label }
                            ))
                        }   
                        clearable={false}
                        multi={false}
                    /> : null 
                } */}
                {
                    !!!this.props.hideRemarks ? <FormGroup controlId="dialog-request-appointment" style = {{marginTop: 5}}>
                        <FormControl
                            componentClass="textarea"
                            value={this.state.currentImageReamrks}
                            placeholder={"Type of document"}
                            onChange = {(e) => this.setState({currentImageReamrks : e ? e.target.value : ''})}
                            style={{height: 50, padding: 5, resize: "none"}} 
                        />
                        </FormGroup> : null
                }

            </div>
        )
    }

    _renderDateDiv = () => {

        const { endedOn, startedOn } = this.state

        return (
            <div className="" style = {{marginTop: 5}}>
                <div className="col-xs-6" style={{padding: 10, borderColor: "lightGray", borderRadius: 10}}>
                    <div className="hsg-upload-start-end-date">
                        <DatePicker
                            className='hsg-input-date-health-locker'
                            calendarClassName='hsg-date-selection'
                            showMonthDropdown
                            showYearDropdown
                            value={startedOn ? moment(startedOn).format(Constants.defaultDateFormat) : 'Start Date'}
                            selected={startedOn ? moment(startedOn) : null}
                            maxDate={moment(this.state.endedOn)}
                            // minDate = {this.state.assessmentPlannerDateStart && moment(this.state.assessmentPlannerDateStart)}
                            onChange={e => {
                                this.setState({"startedOn": e || moment().format(Constants.defaultDateFormat)});
                            }}   
                        />
                    </div>
                </div>
                <div className="col-xs-6" style={{padding: 10, borderColor: "lightGray", borderRadius: 10, border: 3}}>
                    <div className="hsg-upload-start-end-date">
                        <DatePicker
                            className='hsg-input-date-health-locker'
                            calendarClassName='hsg-date-selection'
                            showMonthDropdown
                            showYearDropdown
                            value={endedOn ? moment(endedOn).format(Constants.defaultDateFormat) : 'End Date'}
                            selected={endedOn ? moment(endedOn) : null}
                            minDate = {moment(this.state.startedOn)}
                            onChange={e => {
                                this.setState({"endedOn": e || moment().format(Constants.defaultDateFormat)});
                            }}   
                        />
                    </div>
                </div>
                {/* <DatePicker
                    className='hsg-input-date padding-left-1rem'
                    dateTime={moment().format(Constants.defaultDateFormat)}
                    format={Constants.defaultDateFormat}
                    inputFormat={Constants.defaultDateFormat}
                    viewMode="month"
                    mode="date"
                    // placeholder="Start Date"
                    onChange={e => {
                        this.setState({"startedOn": e || moment().format(Constants.defaultDateFormat)});
                    }}
                />
                <DatePicker
                    className='hsg-input-date padding-left-1rem'
                    dateTime={moment().format(Constants.defaultDateFormat)}
                    format={Constants.defaultDateFormat}
                    inputFormat={Constants.defaultDateFormat}
                    viewMode="month"
                    mode="date"
                    // placeholder="End Date"
                    onChange={e => {
                        this.setState({"endedOn": e || moment().format(Constants.defaultDateFormat)});
                    }}
                /> */}

            </div>
        )
    }

    removeDocument = (index) => {
        let currentImageObject = this.state.currentImageObject
        delete currentImageObject[index]
        this.setState({currentImageObject: currentImageObject})
    }

    showDoc = () => {
        let images = this.state.currentImageObject || []
        return (

            images.map((image, index) => (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={index}>
                    <div className="hsg-add-school-hh-upload-doc-after">
                        <div>
                            {`${image.name}`}
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span
                            aria-hidden="true"
                            data-icon="&#e90b;"
                            className="icon-close hsg-icon-close"
                            onClick={() => this.removeDocument(index)}
                        ></span>
                    </div>
                </div>
            ))
        );
    };

    setCurrentFiles = (obj) => {

        if(obj.length > 1 && !!!this.props.isMultipleUpload) {
            this.errorWhileUpload("multiNotAllowed")
        }else {
            this.setState({ currentImageObject: obj, fileUploadErrorMessage: "" })
        }
    }

    docUploadContainer = () => (
        <UploadDoc
            onFileSubmit={obj => this.setCurrentFiles(obj)}
            fileType={[
                "image/jpeg", 
                "image/png",
                "application/pdf"
            ]}
            multiple={true}
            maxSize={100}
            showError={false}
            image={Image}
            showBadge={false}
            progressBar={false}
            selectedCategory={`DRAG & DROP`}
            showUploadButton={false}
            uploadButtonText="Select File"
            errorWhileUpload={this.errorWhileUpload}
            styleDefs={styleDefs}
        />
    )

    _renderUploadDiv = (props, state) => (
        <div className="hsg-hh-upload-pic" >
            { this.docUploadContainer() }
            {
                this.state.fileUploadErrorMessage && 
                    <p className="hsg-error">{
                        this.state.fileUploadErrorMessage
                    }</p>
            }
        </div>
    );

    uploadImage = () => {
        let { currentImageObject, currentImageTags, currentImageReamrks } = this.state
        let { contentId, category, group, subCategory, isStudent } = this.props

        let custom  = {
            tag: currentImageTags,
            remark: currentImageReamrks,
            subType: subCategory || currentImageReamrks || 'Others',
            startedOn: this.state.startedOn,
            endedOn: this.state.endedOn
        }

        if(currentImageObject && currentImageObject.length && (currentImageReamrks || isStudent && subCategory)){
            this.props.uploadDocuments(currentImageObject, contentId, category, group, custom)
            this.setState({
                currentImageObject: [],
                currentImageReamrks: '',
                currentImageTags: []
            })
            this.props.onHide && this.props.onHide()
        }else{
            this.setState({
                fileUploadErrorMessage: currentImageObject && currentImageObject.length ? "Please add type of document" : "Please select/Drag & Drop documents"
            })
        } 

    };  

    render = () => {
        const { props, state } = this;

        let buttons = [
            {className:"hsg-btn right", onClick:()=>{this.uploadImage()}, text:"Upload"},
            {className:"hsg-btn-white right", onClick:()=>{this.props.onHide()}, text:"Close"}
        ]

        return (
            <Modal show={props.show} onHide={props.onHide} bsSize={props.bsSize} backdropStyle={HSGPopupBackdropStyle}>
                <Modal.Header>
                    {this.getPopUpHeader(props.header)}
                    {this.getPopUpHeaderRight(props.headerRight)}
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <div className="col-xs-12">
                            {
                                !!!props.isMultipleUpload && 
                                
                                (
                                    <div>
                                        <hr/>
                                        <p style={{fontWeight: "bold", fontSize: 14, color:"#929299"}}>
                                            Only one document can be uploaded. 
                                        </p>
                                        <p style={{fontWeight: "bold", fontSize: 14, color:"#929299"}}>
                                            {props.customMSG}
                                        </p>
                                        <hr />
                                    </div>
                                )
                            }
                            {
                                <p style={{fontWeight: "bold", fontSize: 14, color:"#929299"}}>
                                    Supported Files: jpeg, png, and pdf. 
                                </p>
                            }
                            {
                                <div>
                                    <div className="col-xs-12">
                                        {this._renderUploadDiv(props, state)}
                                    </div>
                                    <div>
                                        {!!!props.hideRemarks && this._renderInfoDiv()}
                                    </div>
                                    <div>
                                        {props.isForMedicalLeave && this._renderDateDiv()}
                                    </div>
                                </div>
                            }
                            
                        </div>
                        <div className="col-xs-12">
                            <div className="col-xs-12" style = {{maxHeight: 300, overflow: 'auto', marginTop: 10}}>
                                {this.showDoc()}
                            </div>
                        </div>
                    </Grid>
                </Modal.Body>
                <Modal.Footer>{this.getButtons(buttons)}</Modal.Footer>
            </Modal>
        );
    };
}

HSGPopupComponent.defaultProps = {
    isForm: false
};

HSGPopupComponent.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    header: PropTypes.string,
    headerRight: PropTypes.string,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            className: PropTypes.string,
            onClick: PropTypes.func.isRequired,
            text: PropTypes.string.isRequired
        })
    ),
    category: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/Containers/HealthLockerContainer/Component/UploadDocumentPopup.js